/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
import type { ReducedBlogV2TagType } from "types/blog-v2-types"
import React from "react"

import { preventWidow } from "utils/preventWidow"
import { blogSlug } from "components/Blog/utils/Blog.utils"
import {
  container,
  breadcrumbContainer,
  breadcrumbFlex,
  breadcrumbLink,
  spacer,
  breadcrumbLinkLite,
} from "./PostBreadcrumb.css"

type Props = {
  tag: ReducedBlogV2TagType
  slug: string
  title: string
  locale: "en-GB" | "en-US"
}

export const PostBreadcrumb: React.FC<Props> = ({
  tag,
  slug,
  title,
  locale,
}) => {
  let blogSlugToUse = blogSlug
  if (locale === "en-US") {
    blogSlugToUse = `/us${blogSlug}`
  }
  return (
    <div className={container}>
      <div className={breadcrumbContainer}>
        <div className={breadcrumbFlex}>
          <a
            className={breadcrumbLinkLite}
            href={blogSlugToUse}
            title="BEAUTY PIE Blog"
          >
            Blog
          </a>
          <p className={spacer}>/</p>
          <a
            className={breadcrumbLinkLite}
            href={`${blogSlugToUse}/tag/${tag.slug}`}
            title={tag.title}
            dangerouslySetInnerHTML={preventWidow(tag.title)}
          />
          <p className={spacer}>/</p>
        </div>
        <a
          className={breadcrumbLink}
          href={`${blogSlugToUse}/${slug}`}
          title={title}
          dangerouslySetInnerHTML={preventWidow(title)}
        />
      </div>
    </div>
  )
}
